import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import {
  MarkMaintenanceRequestAsNeedsReview,
  MarkMaintenanceRequestAsNeedsReviewVariables,
} from '../../../athena/types/MarkMaintenanceRequestAsNeedsReview';

export const MUTATION = gql`
  mutation MarkMaintenanceRequestAsNeedsReview($maintenanceRequestId: String!) {
    webMaintenance {
      markMaintenanceRequestAsNeedsReview(input: { maintenanceRequestId: $maintenanceRequestId }) {
        _empty
      }
    }
  }
`;

export const useMarkMaintenanceRequestAsNeedsReview = () => {
  return useMutation<
    MarkMaintenanceRequestAsNeedsReview,
    MarkMaintenanceRequestAsNeedsReviewVariables
  >(MUTATION);
};
